// Circles to Scroll along with small buttons below find it here :  

// import React from "react";
// import { Typography, Box, useMediaQuery } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import CountUpAnimation from "../../../components/common/CountUpAnimation";

// const BJSPresence = ({ data }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery("(max-width:1000px)");
//   const [activeIndex, setActiveIndex] = React.useState(0);

//   const handleScroll = (e) => {
//     const el = e.target;
//     const scroll = el.scrollLeft;
//     const width = el.clientWidth;
//     const index = Math.round(scroll / (width * 0.6));
//     setActiveIndex(index);
//   };

//   const isTablet = useMediaQuery("(min-width:577px) and (max-width:1025px)");
//   const items = [
//     { number: 40, label: "Years of BJS" },
//     { number: data?.totalPrograms || 0, label: "Programs" },
//     { number: `57 L`, label: "Lives Impacted" },
//     { number: '1745' || 0, label: "Office Bearers" },
//     {
//       number: "41",
//       label: "Volunteers",
//     },

//   ];

//   const CircleCard = ({ number, label }) => (
//     <Box display="flex" flexDirection="column" alignItems="center" gap={1} sx={{width:"150px"}}>
//       <Box
//         sx={{
//           border: `12px solid #E9D4FF`,
//           borderRadius: "50%",
//         }}
//       >
//         <Box
//           sx={{
//             width: { xs: 100, sm: 130 },
//             height: { xs: 100, sm: 130 },
//             borderRadius: "50%",
//             border: `1.5px solid #9946DF`,
//             background: theme.palette.background.paper,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//            //boxShadow: "0px 5px 10px rgba(0,0,0,0.6) inset",
//           }} 
//         > 
//           <Typography
//             sx={{
//               color: "#9946DF",
//               fontWeight: 800,
//               fontFamily: theme.typography.numberFont,
//               fontSize: { xs: "1.2rem !important", sm: "2.5rem !important",  md: "3rem",},
//             }}
//           >
//           <CountUpAnimation from={0} to={number} duration={1} />
//            {label === "Lives Impacted" ? "L+" : label === "Volunteers" ? "K+" : "+"}
//           </Typography>
//         </Box>
//       </Box>

//       <Typography
//         sx={{
//           textAlign: "center",
//           fontWeight: "bolder",
//           fontSize: { xs: "1.2rem", sm: "1.5rem" },
//           width: { xs: 150, sm: 200 },
//         }}
//       >
//         {label}
//       </Typography>
//     </Box>
//   );

//   return (
//     <Box sx={{ backgroundColor: theme.palette.background.paper, py: 3 }}>

//       {/* TITLE */}
//       <Typography
//         variant="h4"
//         sx={{
//           color: theme.palette.primary.LPtitles,
//           fontWeight: "900",
//           fontSize: {xs:"20px",sm:"27px", md:"36px"},
//           textAlign: "center",
//           m:1
//         }}
//       >
//         BJS Scale
//       </Typography>

//       {/* DESKTOP */}
//       {!isMobile && (
//         <Box
//           sx={{
//             maxWidth: 1200,
//             mx: "auto",
//             marginTop:"50px",
//           //  overflow: "scroll",
//             display: "flex",
//             justifyContent: "space-between",
//          //   gap: 3,
//             px: 3,
//           }}
//         >
//           {items.map((item, index) => (
//             <CircleCard key={index} {...item} />
//           ))}
//         </Box>
//       )}

//       {/* MOBILE / TABLET */}
//       {isMobile && (
//         <>
//           <Box
//             onScroll={handleScroll}
//             sx={{
//               display: "flex",
//               overflowX: "auto",
//               gap: 0,
//               pl: 2,
//               pr: 2,
//               scrollBehavior: "smooth",
//               scrollPaddingLeft: "24px",
//               scrollPaddingRight: "24px",
//               overflow: "scroll",
//             }}
//           >
//             {items.map((item, index) => (
//               <Box key={index} sx={{
//                 flex: "0 0 auto",
//                 minWidth: { xs: 160, sm: 200 },
//               }}>
//                 <CircleCard {...item} />
//               </Box>
//             ))}
//           </Box>

//           {/* Indicators */}
//           <Box display="flex" justifyContent="center" mt={1} gap={1}>
//             {(isTablet ? [0, 1] : [0, 1, 2]).map((_, i) => (
//               <Box
//                 key={i}
//                 sx={{
//                   width: 22,
//                   height: 5,
//                   borderRadius: 3,
//                   transition: "0.3s",
//                   backgroundColor:
//                     i === activeIndex
//                       ? theme.palette.primary.main
//                       : theme.palette.grey[300],
//                 }}
//               />
//             ))}
//           </Box>
//         </>
//       )}
//     </Box>
//   );
// };

// export default BJSPresence;









import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CountUpAnimation from "../../../components/common/CountUpAnimation";

const BJSPresence = ({ data }) => {
  const theme = useTheme();
  // const [activeIndex, setActiveIndex] = React.useState(0);

  const items = [
    { number: 40, suffix: "+", label: "Years of BJS" },
    { number: data?.totalPrograms || 30, suffix: "+", label: "Programs" },
    { number: 10, suffix: "L+", label: "Lives Impacted" },
    { number: 40, suffix: "k+", label: "Volunteers" },
    { number: 5, suffix: "k+", label: "Office Bearers" },
  ];

  const topRow = items.slice(0, 3);
  const bottomRow = items.slice(3);

  // const handleScroll = (e) => {
  //   const el = e.target;

  //   const scrollPosition = el.scrollLeft;
  //   const maxScroll = el.scrollWidth - el.clientWidth;

  //   // const index = scrollPosition > maxScroll / 2 ? 1 : 0;
  //   const index = Math.round(
  //     scrollPosition / (el.clientWidth * 0.7)
  //   );

  //   setActiveIndex(index);
  // };

  const CircleCard = ({ number, suffix, label }) => (
    <Box
      textAlign="center"
      sx={{
        minWidth: {
          xs: 110,
          sm: 150,
          md: "auto",
        },
      }}
    >
      <Box
        sx={{
          width: {
            xs: 90,
            sm: 100,
            md: 110,
            lg: 140,
            xl: 160,
            xxl: 190,
          },

          height: {
            xs: 90,
            sm: 100,
            md: 110,
            lg: 140,
            xl: 160,
            xxl: 190,
          },

          borderRadius: "50%",
          border: {
            xs: "8px solid #E9D4FF",
            lg: "10px solid #E9D4FF",
            xxl: "14px solid #E9D4FF",
          },

          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            border: "2px solid #9946DF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
          }}
        >
          {/* <Typography
            sx={{
              color: "#9946DF",
              fontWeight: { xs: 800, md: 800 },

              fontSize: {
                xs: "18px",
                sm: "20px",
                md: "22px",
                lg: "24px",
                xl: "30px",
                xxl: "36px",
              },
              
            }}
          >
            <CountUpAnimation from={0} to={number} duration={1} />
            {suffix}
          </Typography> */}

          <Typography
            sx={{
              color: "#000",
              fontWeight: 800,

              "& .count-up": {
                fontSize: {
                  xs: "22px",
                  sm: "24px",
                  md: "24px",
                  lg: "30px",
                  xl: "36px",
                  xxl: "40px",
                }
              },
            }}
          >
            {/* <Box
              component="span"
              sx={{
                fontSize: "inherit",
                fontWeight: "inherit",
                lineHeight: "inherit",
              }}
            > */}
            <CountUpAnimation from={0} to={number} duration={1} className="count-up" />
            {/* </Box> */}

            <Box
              component="span"
              sx={{
                fontSize: {
                  xs: "22px",
                  sm: "24px",
                  md: "24px",
                  lg: "30px",
                  xl: "36px",
                  xxl: "40px",
                }
              }}
            >
              {suffix}
            </Box>
          </Typography>
        </Box>
      </Box>

      <Typography
        sx={{
          mt: 1.5,
          fontWeight: { xs: 300, sm: 700 },

          fontSize: {
            xs: "10px",
            sm: "24px",
            md: "36px",
            lg: "48px",
            xl: "56px",
            xxl: "64px",
          },
        }}
      >
        {label}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        py: {
          xs: 4,
          lg: 4,
        },
        
        backgroundColor: theme.palette.background.paper,
        textAlign: "center",
      }}
    >
      {/* TITLE */}
      <Typography
      variant="h1"
        sx={{
          fontWeight: 800,

          fontSize: {
            xs: "18px",
            sm: "27px",
            md: "36px",
            lg: "36px",
            xl: "36px",
            xxl: "40px",
          },

          mb: {
            xs: 3,
            lg: 5,
          },
        }}
      >
        BJS Scale
      </Typography>

      {/* XS → HORIZONTAL SCROLL */}
      {/* <Box
        sx={{
          display: {
            xs: "block",
            sm: "none",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 3,
            px: 2,
            pb: 1,
            scrollBehavior: "smooth",

            "&::-webkit-scrollbar": {
              display: "none",
            },

            scrollbarWidth: "none",
          }}
          onScroll={handleScroll}
        >
          {items.map((item, i) => (
            <CircleCard key={i} {...item} />
          ))}
        </Box>

        {/* PILLS 
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1,
            mt: 2,
          }}
        >
          {[0, 1].map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 24,
                height: 5,
                borderRadius: 10,
                backgroundColor:
                  i === activeIndex
                    ? theme.palette.primary.main
                    : theme.palette.grey[300],
              }}
            />
          ))}
        </Box>
      </Box> */}

      {/* SM + MD → 3 + 2 GRID */}
      <Box
        sx={{
          display: {
            xs: "flex",
            // display: "flex",

            "@media (min-width:769px)": {
              display: "none",
            },
          },

          flexDirection: "column",
          alignItems: "center",

          gap: {
            sm: 5,
            md: 6,
            lg: 4,
            xl:4,
            xxl:5
          },
        }}
      >
        {/* TOP ROW */}
        <Box
          sx={{
            display: { xs: "flex" },
            // display: { xs: "flex", sm: "grid" },

            gridTemplateColumns: "repeat(3, 1fr)",

            gap: {
              xs: 0,
              sm: 4,
              md: 5,
            },

            "@media (min-width:400px)": {
              gap: 2,
              mb: 1
            },

            "@media (min-width:500px)": {
              gap: 3,
              mb: 2
            },

            // justifyItems: "center",
            justifyContent: "center",
            // justifyContent: { xs: "center" },

            // mx: "auto",
            maxWidth: {
              xs: 330,
              sm: 520,
              md: 700,
            },
            // "@media (min-width:400px)": {
            //   maxWidth: 400,
            // },

            // "@media (min-width:500px)": {
            //   maxWidth: 500,
            // },
          }}
        >
          {topRow.map((item, i) => (
            <CircleCard key={i} {...item} />
          ))}
        </Box>

        {/* BOTTOM ROW */}
        <Box
          sx={{
            display: { xs: "flex", sm: "grid" },
            justifyContent: { xs: "center" },
            gridTemplateColumns: "repeat(2, 1fr)",

            gap: {
              xs: 2,
              sm: 6,
              md: 8,
            },

            "@media (min-width:500px)": {
              gap: 3,
            },

            justifyItems: "center",
          }}
        >
          {bottomRow.map((item, i) => (
            <CircleCard key={i} {...item} />
          ))}
        </Box>
      </Box>

      {/* LG+ → PERFECT 5 COLUMN */}
      <Box
        sx={{
          display: "none",

          "@media (min-width:769px)": {
            display: "flex",
          },

          justifyContent: "space-around",

          alignItems: "center",

          maxWidth: {
            md: 950,
            lg: 1200,
            xl: 1500,
            xxl: 1800,
          },

          mx: "auto",

          px: {
            lg: 2,
            xl: 4,
          },
        }}
      >
        {items.map((item, i) => (
          <CircleCard key={i} {...item} />
        ))}
      </Box>
    </Box>
  );
};

export default BJSPresence;